import { HttpClient } from "@angular/common/http";
import { AbstractService } from "../core/AbstractService";
import { Injectable } from "@angular/core";
import { env } from "../../env/env";

import { StructureRequest } from "../data/http/requests/strcuture.req";
import { StructureResponse } from "../data/http/responses/strcuture.res";
import { AppService } from "../core/app.service";
import { Observable } from 'rxjs';
import { ApiResponse } from '../data/http/responses/apiresponse.response';

@Injectable({ // Ajoutez le décorateur Injectable
    providedIn: 'root' // Rend le service disponible dans toute l'application
})
export class StructureService extends AbstractService<StructureRequest, StructureResponse>{
    constructor(http: HttpClient, appService: AppService) {
        // pass null for legacy cookies param, and provide appService to AbstractService
        super(`${env.apiUrl}structure`, http, null, appService);
    }

    // Override create to ensure applicationId is set (fallback to AppService)
    override create(data: StructureRequest): Observable<ApiResponse<StructureResponse>> {
        if (!data.applicationId || data.applicationId === 'null') {
            const appId = this.appService?.getAppId() || '';
            data.applicationId = appId;
        }
        return super.create(data);
    }
}